import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { Atlantm30 } from './Atlantm30.types';

export function useAtlantm30Data(): Page<Atlantm30>['templateFields'] {
  return useCurrentPage<Page<Atlantm30>>().templateFields;
}
